export const EDIT_ORGANIZATION = 'EDIT_ORGANIZATION'
export const EDIT_ORGANIZATION_MODAL_OPEN = 'EDIT_ORGANIZATION_MODAL_OPEN'
